import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Support } from '@app/_helpers';
import { TranslateService } from '@ngx-translate/core';
import { DirectionService } from '@services/direction.service';
import * as _ from 'lodash';
import { RouterLink } from '@angular/router';
import { ClickDirective } from '../../shared/directives/click.directive';
import { OwlPreventClickDirective } from '../../shared/directives/owl-prevent-click.directive';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { DepartmentsAreaDirective } from '../../shared/directives/departments-area.directive';
import { NgIf, NgClass, NgFor, KeyValuePipe } from '@angular/common';

@Component({
    selector: 'app-block-slideshow',
    templateUrl: './block-slideshow.component.html',
    styleUrls: ['./block-slideshow.component.scss'],
    standalone: true,
    imports: [NgIf, DepartmentsAreaDirective, NgClass, CarouselModule, OwlPreventClickDirective, NgFor, ClickDirective, RouterLink, KeyValuePipe]
})
export class BlockSlideshowComponent {
    @Input() withDepartments = false;
    @Input() fullWidth: any = false;
    @Input() bannerItems;
    @Input() element;
    options = {
        nav: false,
        dots: true,
        autoHeight: true,
        loop: true,
        lazyLoad: true,
        autoplay: false,
        responsive: {
            0: { items: 1 }
        },
        rtl: this.direction.isRTL()
    };

    /*    getImageUrl(image: string|any, secondaryImage: string|any = null) {
           if( _.isString(image) ) return image;
           else if( image?.url ) return image.url;
           else {
               if( _.isString(secondaryImage) ) return secondaryImage;
               else if( secondaryImage?.url ) return secondaryImage.url;
               else return "";
           }
       } */
    constructor(
        public sanitizer: DomSanitizer,
        private direction: DirectionService,
        public translate: TranslateService,

    ) { }

    ngOnInit() {
        if (this.element) {
            _.merge(this.options, {
                autoHeight: false,
                autoplay: false,
            })
        }
        this.fullWidth = Support.numberToBoolean(this.fullWidth);
        _.forEach(this.bannerItems, item => {
            item.url = this.getItemUrl(item);
        })



    }

    getItemUrl(item) {
        return item?.url?.[this.translate?.currentLang] || item?.url || null;
    }
}
